<template>
 <div class="author">
   <a href="https://github.com/D1LL1G4F">Website by Matej Kňazík</a>
 </div>
</template>

<script>
export default {
  name: "Copyright",
}
</script>

<style lang="less" scoped>
  @import "../styles/colors.less";

  .author a{
    font-size: 10px;
    width: 100%;
    display: block;
    position: relative;
    text-align: right;
    right: 10px;
    padding-bottom: 10px;
    color: @grey;
    text-decoration: none;
  }
  @media screen and (max-width: 500px) {
    .author a {
      padding-top: 20px;
    }
  }
</style>
